var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('h3',[_vm._v("Rozsah")]),_vm._v(" "+_vm._s((new Date(_vm.advertising.dateFrom)).toLocaleDateString())+" - "+_vm._s((new Date(_vm.advertising.dateTo)).toLocaleDateString())+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }